<template>
  <div>
    <div class="flex space-x-4 items-end">
      <BaseFormGroup>
        <BaseFormLabel> Date preset </BaseFormLabel>
        <div>
          <BaseFormSelect
            v-model="datePreset"
            :options="datePresetOptions"
            required
            class="bg-white"
          />
        </div>
      </BaseFormGroup>

      <template v-if="isCustom">
        <BaseFormGroup>
          <BaseFormLabel> Date from </BaseFormLabel>
          <div>
            <BaseFormInput v-model="since" type="date" class="bg-white" />
          </div>
        </BaseFormGroup>

        <BaseFormGroup>
          <BaseFormLabel> Date to </BaseFormLabel>
          <div>
            <BaseFormInput v-model="until" type="date" class="bg-white" />
          </div>
        </BaseFormGroup>
      </template>

      <div class="p-px">
        <BaseButton
          primary
          class="h-10"
          :disabled="dateDiff < 0 || dateDiff > 30"
          @click="handleSubmit"
        >
          Submit
        </BaseButton>
      </div>

      <div class="p-px">
        <BaseButton ghost class="h-10" @click="handleReset"> Reset </BaseButton>
      </div>
    </div>
    <BaseFormInlineMessage danger v-if="rangeMoreThanAYear">
      Range of period cannot be more than a year.
    </BaseFormInlineMessage>
  </div>
</template>

<script>
import moment from 'moment';

const TODAY = 'today';
const YESTERDAY = 'yesterday';
const THIS_WEEK = 'this_week';
const THIS_MONTH = 'this_month';
const THIS_YEAR = 'this_year';
const LAST_WEEK = 'last_week';
const LAST_MONTH = 'last_month';
const LAST_YEAR = 'last_year';
const LAST_30D = 'last_30d';
const LAST_60D = 'last_60d';
const LAST_90D = 'last_90d';
const CUSTOM = 'custom';

const DEFAULT_PRESET = LAST_30D;

const datePresets = {
  CUSTOM: { label: 'Custom', value: CUSTOM },
  TODAY: { label: 'Today', value: TODAY },
  YESTERDAY: { label: 'Yesterday', value: YESTERDAY },
  THIS_WEEK: { label: 'This week', value: THIS_WEEK },
  THIS_MONTH: { label: 'This Month', value: THIS_MONTH },
  THIS_YEAR: { label: 'This year', value: THIS_YEAR },
  LAST_WEEK: { label: 'Last week', value: LAST_WEEK },
  LAST_MONTH: { label: 'Last month', value: LAST_MONTH },
  LAST_YEAR: { label: 'Last year', value: LAST_YEAR },
  LAST_30D: { label: 'Last 30 days', value: LAST_30D },
  LAST_60D: { label: 'Last 60 days', value: LAST_60D },
  LAST_90D: { label: 'Last 90 days', value: LAST_90D },
};

export default {
  data() {
    return {
      datePreset: DEFAULT_PRESET,
      datePresetOptions: [...Object.values(datePresets)],
      since: null,
      until: null,
    };
  },
  computed: {
    dateDiff() {
      if (!this.since || !this.until) {
        return 0;
      }

      return moment(this.until).diff(this.since, 'days');
    },
    rangeMoreThanAYear() {
      if (!this.since || !this.until) {
        return false;
      }

      return moment(this.until).diff(this.since, 'years', true) > 1;
    },
    isCustom() {
      return this.datePreset === CUSTOM;
    },
  },
  created() {
    this.handleReset();
    this.handleSubmit();
  },
  methods: {
    handleSubmit() {
      this.$emit('query', {
        date_preset: this.datePreset || DEFAULT_PRESET,
        ...(this.datePreset === CUSTOM
          ? {
              since: this.since,
              until: this.until,
            }
          : {}),
      });
    },
    handleReset() {
      this.datePreset = DEFAULT_PRESET;
      this.since = null;
      this.until = null;
    },
    changePreset() {
      if (this.datePreset === CUSTOM) {
        this.since = moment().format('YYYY-MM-DD');
        this.until = moment().format('YYYY-MM-DD');
      }
    },
  },
};
</script>
